import React, { VFC } from 'react';

import { Container } from './styles';

const Title: VFC = () => (
  <Container className="wow fadeInUp fast" data-wow-delay="0.5s">
    <div className="colums">
      <div className="column col-ml-auto col-9">
        <span>Opening a new way between cryptocurrencies.</span>
      </div>
    </div>
  </Container>
);

export default Title;
